<form *ngIf="simularForm" [formGroup]="simularForm" (ngSubmit)="continuar()">
    <ca-card ui-3 class="mt-3" *ngIf="tomadorConfig">
        <div ca-card-title>{{'COMUN.DATOS_GENERALES.TITULO' | translate}} {{'COMUN.DATOS_PERSONA.TIPO_PERSONA.TOMADOR' |
            translate}}</div>
        <div ca-card-content>
            <div class="col-4">
                <ca-checkbox id="checkbox_tomador_asegurado" name="checkbox_tomador_asegurado"
                    [checked]="tomadorEsAsegurado" (valueChange)="changeTomadorAsegurado($event)">
                    {{'SALUD.SIMULAR.RADIO_TOMADOR_ASEGURADO' | translate}}
                </ca-checkbox>
            </div>
            <div *ngIf="tomadorConfig" formGroupName="datosPersonalesTomador" class="mt-3 col-6">
                <app-datos-personales [config]="tomadorConfig" [form]="simularForm.get('datosPersonalesTomador')"
                    (personaChange)="onTomadorChange($event)"></app-datos-personales>
            </div>
            <div formGroupName="datosDomicilioTomador" class="col-6 mt-2">
                <app-datos-domicilio 
                    [config]="domicilioTomadorConfig" 
                    [form]="simularForm.get('datosDomicilioTomador')"
                    (domicilioChange)="onDomicilioTomadorChange($event)"></app-datos-domicilio> 
            </div>
        </div>
    </ca-card>

    <ca-card ui-3 class="mt-3">
        <div ca-card-title>{{'COMUN.DATOS_PERSONA.ASEGURADOS' | translate}}</div>
        <div ca-card-content>
            <div formGroupName="datosAsegurados">
                <div class="mt-3 row col-8">
                    <div class="col-6">
                        <ca-checkbox id="checkbox_otros_asegurados" name="checkbox_otros_asegurados"
                            [checked]="mostrarOtrosAsegurados" (valueChange)="changeMostrarOtrosAsegurados($event)"
                            [disabled]="!tomadorEsAsegurado">
                            {{'SALUD.SIMULAR.RADIO_OTROS_ASEGURADOS' | translate}}
                        </ca-checkbox>
                    </div>
                    <div *ngIf="mostrarOtrosAsegurados" formArrayName="asegurados" class="col-2">
                        <button type="button" ca-button-icon-primary (click)="addAsegurado()">
                            <ca-icon>add</ca-icon>
                        </button>
                    </div>
                </div>
                <div *ngIf="mostrarOtrosAsegurados" formArrayName="asegurados" class="mt-3">
                    <div *ngFor="let ag of aseguradosArray.controls; let i = index" [formGroupName]="i" class="row col-4">
                        <div class="col-10 asegurado">
                            <app-datos-personales 
                                [config]="aseguradoConfigs[i]" 
                                [form]="aseguradosArray.at(i)"
                                (personaChange)="onAseguradoChange(i, $event)">
                            </app-datos-personales>
                        </div>
                        <div class="col-2 align-items-center">
                            <button type="button" ca-button-icon-primary (click)="removeAsegurado(i)"
                                [disabled]="aseguradosArray.length <= 1" aria-label="Eliminar asegurado">
                                <ca-icon>remove</ca-icon>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ca-card>

    <ca-card ui-3 class="mt-3" *ngIf="fraccionamientos?.length > 0">
        <div ca-card-title>{{'CATALOGO.DATOS_ADICIONALES.TITULO' | translate}}</div>
        <div ca-card-content>  
            <div formGroupName="datosAdicionales" class="col-6"> 
                <app-datos-adicionales
                    [poliza]="propuesta"
                    [fraccionamientos]="fraccionamientos"
                    [form]="simularForm.get('datosAdicionales')"></app-datos-adicionales>
            </div>
        </div>
    </ca-card> 
    <div class="col-12 text-right mt-3 mb-3">
        <button ca-button class="ca-btn-icon__container ml-2" (click)="continuar()">
            <ca-icon>chevron_right</ca-icon>
            {{'BUSCADOR_POLIZAS.BOTON_CONTINUAR' | translate}}
        </button>
    </div>
</form>